<template>
  <j-modal :title="title" :width="750" :visible="visible" @ok="handleOk" @cancel="handleCancel">
    <a-spin :spinning="loading">
      <a-form :form="form" @keyup.enter.native="handleOk" :label-col="labelCol" :wrapper-col="wrapperCol">
        <!-- 代理先 -->
        <a-form-item :label="$t('disp.agent')">
          <j-input-popup
            style="width: 272px"
            v-decorator="['agentId', validatorRules.agentId]"
            :placeholder="$t('disp.ph.select', [$t('disp.agent')])"
            component="SelectUserTreeModal"
            :params="{
              multiFlg: '0',
              departFlg: '1',
            }"
            @change="setAgentInfo"
          ></j-input-popup>
        </a-form-item>

        <!-- 代理期間 -->
        <a-form-item :label="$t('disp.agent.applyDateRange')">
          <a-range-picker
            style="width: 272px"
            :placeholder="[$t('disp.ph.ymdStart'), $t('disp.ph.ymdEnd')]"
            format="YYYY-MM-DD"
            @change="onApplyDateChange"
            v-decorator="[
              'applyDateRange',
              {
                initialValue: applyDateRangeInit,
                rules: [{ required: true, message: this.$t('disp.rules.require') }],
              },
            ]"
          />
        </a-form-item>

        <!-- 委譲権限 -->
        <a-form-item :label="$t('disp.agent.delegationPerms')">
          <j-dict-select-tag
            v-decorator="['delegationPerms', validatorRules.delegationPerms]"
            :type="'radio'"
            :triggerChange="true"
            dictCode="delegation_perms"
          />
        </a-form-item>

        <!-- 権限対象設定 -->
        <a-form-item :label="$t('disp.agent.permissionSet')">
          <div>
            <a-transfer
              :data-source="permissionList"
              :titles="['', '']"
              :list-style="{
                width: 'calc(50% - 24px)',
                height: '298px',
              }"
              :target-keys="targetKeys"
              :selected-keys="selectedKeys"
              :render="(item) => item.title"
              :disabled="disabled"
              @change="handleChange"
              @selectChange="handleSelectChange"
              @scroll="handleScroll"
            />
          </div>
        </a-form-item>

        <!-- 备注 -->
        <a-form-item :label="$t('disp.note')">
          <a-textarea
            @keyup.enter.stop
            :placeholder="$t('disp.ph.input', [$t('disp.note')])"
            v-decorator="['memo', {}]"
            :maxLength="255"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import pick from 'lodash/pick'
import { deleteAction, postAction, getAction } from '@/api/manage'
import { addRole, editRole, duplicateCheck } from '@/api/api'
import JInputPopup from '@/components/JInputPopup'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import moment from 'moment'

export default {
  name: 'AgentModal',
  components: {
    JInputPopup,
    JDictSelectTag,
  },
  props: {
    rootOpened: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      title: '代理先設定画面',
      visible: false,
      keyId: '',
      model: {},
      // 権限対象設定
      permissionList: [],
      // 権限対象設定
      targetKeys: [],
      // 権限対象設定selectedKeys
      selectedKeys: [],
      // 権限対象設定disabled
      disabled: false,
      // 期间（编辑用）
      applyDateRangeInit: [],
      // 代理先param
      parentParams: { status: '1', multiFlg: '0' },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      loading: false,
      form: this.$form.createForm(this),
      // 代理先
      agentId: '',
      validatorRules: {
        agentId: {
          rules: [{ required: true, message: this.$t('disp.rules.require') }],
        },
        delegationPerms: {
          rules: [{ required: true, message: this.$t('disp.rules.require') }],
        },
      },
      url: {
        add: '/blaze-sys/k00/k0011/AgentManage/add',
        edit: '/blaze-sys/k00/k0011/AgentManage/edit',
        check: '/blaze-sys/k00/k0011/AgentManage/check',
        permissionList: '/blaze-sys/k00/k0011/AgentManage/permissionList',
      },
    }
  },
  created() {},
  methods: {
    moment,
    /** 代理設定init */
    agentInfoInit() {
      this.clearPermissionList()
      getAction(this.url.permissionList, { id: null }).then((res) => {
        if (res.success) {
          let permissionList = res.result
          for (let i = 0; i < permissionList.length; i++) {
            this.permissionList.push({
              key: permissionList[i].id,
              title: permissionList[i].name,
            })
          }
        }
      })
    },
    add() {
      this.edit({})
      this.keyId = ''
    },
    edit(record) {
      this.form.resetFields()
      this.keyId = record.permissionName

      this.model = Object.assign({}, record)
      this.visible = true

      this.$nextTick(() => {
        // 委譲権限：全て
        this.model.delegationPerms = '0'
        this.form.setFieldsValue(pick(this.model, 'delegationPerms', 'permissionName'))
      })

      this.applyDateRangeInit = [
        // 代理期間From：システム日付
        moment(),
        this.model.applyEndDate ? moment(this.model.applyEndDate) : null,
      ]

      this.agentInfoInit()
    },
    /** formDataとして整理 */
    classifyIntoFormData(formData) {
      return {
        agentInfo: formData,
        agentDetailList: this.targetKeys,
      }
    },
    /** 代理設定 */
    setAgentInfo(newName) {
      if (newName.length > 0) {
        this.agentId = newName[0].value
      }
    },
    /** リストをクリア */
    clearPermissionList() {
      this.permissionList = []
      this.targetKeys = []
      this.selectedKeys = []
    },
    /** 代理期間change */
    onApplyDateChange: function (value, dateString) {
      this.form.applyStartDate = dateString[0]
      this.form.applyEndDate = dateString[1]
    },
    handleChange(nextTargetKeys, direction, moveKeys) {
      this.targetKeys = nextTargetKeys
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys]
    },
    handleScroll(direction, e) {},
    handleDisable(disabled) {
      this.disabled = disabled
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.clearPermissionList()
    },
    handleOk() {
      const that = this
      // フォーム検証をトリガー
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // 権限対象設定
          if (JSON.stringify(this.targetKeys) == '{}' || this.targetKeys.length == 0) {
            return this.$notification.error({
              message: this.$t('disp.error'),
              description: this.$t('msg.E_K0011008_02', [this.$t('disp.agent.permissionInfo')]),
            })
          }
          // 系统日付
          let nowDate = moment().utc().format('YYYY-MM-DD')
          let endDate = moment(that.form.applyEndDate)
          // システム日付は代理期間以外　且つ　代理期間が過去時間の場合
          if (endDate.isBefore(nowDate)) {
            this.$confirm({
              title: that.$t('msg.W_K0011008_04'),
              onOk() {
                that.doAdd(values)
              },
            })
          } else {
            that.doAdd(values)
          }
        }
      })
    },
    handleCancel() {
      this.close()
    },
    doAdd(values) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }
      const that = this
      // 追加
      let formData = this.classifyIntoFormData(values)
      formData.agentInfo.applyStartDate = that.form.applyStartDate
      formData.agentInfo.applyEndDate = that.form.applyEndDate
      formData.agentInfo.agentId = this.agentId
      postAction(this.url.add, formData)
        .then((res) => {
          if (res.success) {
            // 権限対象設定の右欄データが処理①で取得した権限情報に存在しないの場合
            if (res.message == 'msg.E_K0011008_03' || res.message == 'msg.E_K0011008_04') {
              let menuName = []
              for (let i = 0; i < that.permissionList.length; i++) {
                if (res.result.menuIdList.includes(that.permissionList[i].key)) {
                  menuName.push(that.permissionList[i].title)
                }
              }
              this.$notification.error({
                message: that.$t('disp.error'),
                description: that.$t(res.message, [that.$t(menuName.join(','))]),
              })
            } else {
              // 处理成功
              that.$message.success(that.$t(res.message))
              that.$emit('close')
              that.visible = false
              that.clearPermissionList()
              that.$emit('searchQuery')
            }
          }
        })
        .finally(() => {
          that.loading = false
        })
    },
  },
}
</script>

<style scoped></style>
